import { Box, Button, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { ContentContainer } from "../Payment/components/styles"
import UIIcon from "../../components/UIIcon"

export const CitizenRestricted = () => {
  const navigate = useNavigate()
  const handleClick = () => {
    navigate("/quit", {
      replace: true,
    })
  }
  return (
    <Box sx={ContentContainer}>
      <Box
        display="flex"
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
        height="100%"
        pb="150px"
        gap={4}
      >
        <UIIcon iconName="alertIcon" size={80} />

        <Typography variant="h3" fontWeight={700} textAlign="center">
          В настоящее время <br /> переводы доступны только <br /> гражданам Кыргызстана
        </Typography>

        <Typography variant="h5" fontWeight={600} textAlign="center" color="text.secondary">
          Скоро сервис переводов будет <br /> доступен всем
        </Typography>

      </Box>

      <Box mt="auto" sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <Button variant="contained" color="secondary" onClick={handleClick}>
          Закрыть
        </Button>
      </Box>
    </Box>
  )
}
